export default __webpack_public_path__ + "static/media/45.79511907.jpeg";